import { Grid, Typography, TextField, MenuItem, Box, } from "@mui/material";
import useMyLocationSessions from "./useMyLocationSessions";
export type SelectDateProps = {
    onSelect: (option: string) => void;
}

export default function SelectTriageDate({ onSelect }: SelectDateProps) {
    const { sessionDates } = useMyLocationSessions()
    return (
        <>
            {
                sessionDates.length > 0 ?
                    <>
                        <Grid size={12} direction="column" alignItems="center" textAlign="center">
                            <Typography>What day did you launch the sessions?</Typography>
                            <Box sx={{ paddingTop: ".5rem" }}>
                                <TextField label="Session Date" name="date" required
                                    fullWidth
                                    defaultValue={""}
                                    select
                                    onChange={(choice) => {
                                        onSelect(choice.target.value)
                                    }}
                                >
                                    {sessionDates.map((sessionDate) => (
                                        <MenuItem value={sessionDate}>{sessionDate}</MenuItem>
                                    ))}
                                </TextField>
                            </Box>
                        </Grid>
                    </>
                    :
                    <>
                        <Grid size={12} direction="column" alignItems="center">
                            <Typography>You have yet to run any sessions at this location.</Typography>
                        </Grid>
                    </>
            }
        </>
    )
}